import { Box, SxProps, Theme, Typography, Grid } from '@mui/material';

interface CriteriaListProps {
  criteriaArr?: string[][];
  title?: string;
  sx?: SxProps<Theme>;
  emptyRequirementLabel?: string;
}
export const CriteriaList: React.FC<CriteriaListProps> = ({
  criteriaArr,
  sx,
  title,
  emptyRequirementLabel = 'No requirements are needed to be fulfilled.',
}) => {
  return (
    <Box sx={sx}>
      {title && (
        <Typography sx={{ mb: 1.5 }} variant="body1" fontWeight="Bold" component="h6">
          {title}
        </Typography>
      )}
      {criteriaArr && criteriaArr.length > 0 ? (
        <Box sx={{ listStyle: 'none' }} component="ul">
          {criteriaArr.map((criteria, index) => (
            <Box component="li" sx={index + 1 !== criteriaArr.length ? { mb: 1.5 } : undefined} key={index}>
              <Grid container flexWrap="nowrap" spacing={{ xs: 1, md: 1.5 }}>
                <Grid item>
                  <Typography variant="paragraph">{index + 1})</Typography>
                </Grid>
                <Grid item xs>
                  {criteria.map((criterion, index) => (
                    <div key={index}>
                      <Typography paragraph sx={{ mb: 0 }} variant="paragraph" component="p">
                        {criterion}
                      </Typography>
                      {index + 1 !== criteria.length && (
                        <Typography color="secondary" paragraph sx={{ mb: 0 }} variant="paragraph">
                          or
                        </Typography>
                      )}
                    </div>
                  ))}
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography paragraph variant="paragraph">
          {emptyRequirementLabel}
        </Typography>
      )}
    </Box>
  );
};
